var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !(
    _vm.data["custom_field_data_type"] == "file" &&
    _vm.fileList.length <= 0 &&
    !_vm.iSEdited
  )
    ? _c(
        "v-col",
        {
          attrs: {
            xs: _vm.formStyle && _vm.formStyle.xs ? _vm.formStyle.xs : 12,
            sm: _vm.formStyle && _vm.formStyle.sm ? _vm.formStyle.sm : 12,
            md: _vm.formStyle && _vm.formStyle.md ? _vm.formStyle.md : 6,
            lg: _vm.formStyle && _vm.formStyle.lg ? _vm.formStyle.lg : 6,
            xl: _vm.formStyle && _vm.formStyle.xl ? _vm.formStyle.xl : 4,
            cols: _vm.formStyle && _vm.formStyle.cols ? _vm.formStyle.cols : 12,
          },
        },
        [
          _vm.data && _vm.data["custom_field_data_type"] == "multiLang"
            ? _c("inputTextFiledMultiLang", {
                attrs: {
                  bindData: _vm.curvalue,
                  maxlength: "100",
                  readonly: !_vm.iSEdited,
                  filled: _vm.iSEdited,
                  placeholder: _vm.$getCommonLangValue(
                    _vm.data["custom_field_placeholder"]
                  ),
                  label: _vm.$getCommonLangValue(_vm.data["custom_field_name"]),
                  rules: Number(_vm.data.is_required)
                    ? _vm.$GetRules(["_Require_Rules"], [null])
                    : [],
                },
                on: {
                  change: function (valueArr) {
                    _vm.curvalue = valueArr
                  },
                },
              })
            : _vm.data && _vm.data["custom_field_data_type"] == "text"
            ? [
                _c(
                  "v-sheet",
                  {
                    staticClass: "text--secondary",
                    class: Number(_vm.data.is_required)
                      ? " mrc_text_require "
                      : "",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$getCommonLangValue(_vm.data["custom_field_name"])
                        ) +
                        " "
                    ),
                  ]
                ),
                _c("v-textarea", {
                  attrs: {
                    rows: "5",
                    "no-resize": "",
                    maxlength: "500",
                    readonly: !_vm.iSEdited,
                    placeholder: _vm.$getCommonLangValue(
                      _vm.data["custom_field_placeholder"]
                    ),
                    filled: _vm.iSEdited,
                    dense: "",
                    counter: "500",
                    "single-line": "",
                    rules: Number(_vm.data.is_required)
                      ? _vm.$GetRules(["_Require_Rules"], [null])
                      : [],
                    name: "input-7-4",
                  },
                  model: {
                    value: _vm.curvalue,
                    callback: function ($$v) {
                      _vm.curvalue = $$v
                    },
                    expression: "curvalue",
                  },
                }),
              ]
            : _vm.data && _vm.data["custom_field_data_type"] == "string"
            ? _c("normalInputTextFiled", {
                attrs: {
                  maxlength: "100",
                  readonly: !_vm.iSEdited,
                  filled: _vm.iSEdited,
                  placeholder: _vm.$getCommonLangValue(
                    _vm.data["custom_field_placeholder"]
                  ),
                  label: _vm.$getCommonLangValue(_vm.data["custom_field_name"]),
                  rules: Number(_vm.data.is_required)
                    ? _vm.$GetRules(["_Require_Rules"], [null])
                    : [],
                },
                model: {
                  value: _vm.curvalue,
                  callback: function ($$v) {
                    _vm.curvalue = $$v
                  },
                  expression: "curvalue",
                },
              })
            : _vm.data && _vm.data["custom_field_data_type"] == "double"
            ? _c("normalInputTextFiled", {
                attrs: {
                  maxlength: "100",
                  placeholder: _vm.$getCommonLangValue(
                    _vm.data["custom_field_placeholder"]
                  ),
                  type: "number",
                  readonly: !_vm.iSEdited,
                  filled: _vm.iSEdited,
                  label: _vm.$getCommonLangValue(_vm.data["custom_field_name"]),
                  rules: Number(_vm.data.is_required)
                    ? _vm.$GetRules(["_Require_Rules"], [null])
                    : [],
                },
                model: {
                  value: _vm.curvalue,
                  callback: function ($$v) {
                    _vm.curvalue = $$v
                  },
                  expression: "curvalue",
                },
              })
            : _vm.data && _vm.data["custom_field_data_type"] == "float"
            ? _c("normalInputTextFiled", {
                attrs: {
                  maxlength: "100",
                  readonly: !_vm.iSEdited,
                  filled: _vm.iSEdited,
                  placeholder: _vm.$getCommonLangValue(
                    _vm.data["custom_field_placeholder"]
                  ),
                  type: "number",
                  label: _vm.$getCommonLangValue(_vm.data["custom_field_name"]),
                  rules: Number(_vm.data.is_required)
                    ? _vm.$GetRules(["_Require_Rules"], [null])
                    : [],
                },
                model: {
                  value: _vm.curvalue,
                  callback: function ($$v) {
                    _vm.curvalue = $$v
                  },
                  expression: "curvalue",
                },
              })
            : _vm.data && _vm.data["custom_field_data_type"] == "int"
            ? _c("numberInputTextFiled", {
                attrs: {
                  maxlength: "11",
                  readonly: !_vm.iSEdited,
                  filled: _vm.iSEdited,
                  placeholder: _vm.$getCommonLangValue(
                    _vm.data["custom_field_placeholder"]
                  ),
                  rules: _vm.$GetRules(
                    ["_Number_negative", "_Length_Rules"],
                    [null, 11]
                  ),
                  label: _vm.$getCommonLangValue(_vm.data["custom_field_name"]),
                  isNotRequire: "",
                },
                model: {
                  value: _vm.curvalue,
                  callback: function ($$v) {
                    _vm.curvalue = $$v
                  },
                  expression: "curvalue",
                },
              })
            : _vm.data && _vm.data["custom_field_data_type"] == "datetime"
            ? _c("DateTimePicker", {
                attrs: {
                  rules: Number(_vm.data.is_required)
                    ? _vm.$GetRules(["_Require_Rules"], [null])
                    : [],
                  type: "datetime",
                  defaultTime: _vm.curvalue,
                  readonly: !_vm.iSEdited,
                  filled: _vm.iSEdited,
                  label: _vm.$getCommonLangValue(_vm.data["custom_field_name"]),
                  placeholder: _vm.$getCommonLangValue(
                    _vm.data["custom_field_placeholder"]
                  ),
                },
                on: {
                  change: function (time) {
                    _vm.curvalue = time
                  },
                },
              })
            : _vm.data && _vm.data["custom_field_data_type"] == "date"
            ? _c("DateTimePicker", {
                attrs: {
                  rules: Number(_vm.data.is_required)
                    ? _vm.$GetRules(["_Require_Rules"], [null])
                    : [],
                  type: "date",
                  defaultTime: _vm.curvalue,
                  readonly: !_vm.iSEdited,
                  filled: _vm.iSEdited,
                  label: _vm.$getCommonLangValue(_vm.data["custom_field_name"]),
                  placeholder: _vm.$getCommonLangValue(
                    _vm.data["custom_field_placeholder"]
                  ),
                },
                on: {
                  change: function (time) {
                    _vm.curvalue = time
                  },
                },
              })
            : _vm.data && _vm.data["custom_field_data_type"] == "time"
            ? _c("TimePicker", {
                attrs: {
                  isRequire: "",
                  disable: !_vm.iSEdited,
                  value: _vm.curvalue,
                  defaultTime: _vm.curvalue,
                  placeholder: _vm.$getCommonLangValue(
                    _vm.data["custom_field_placeholder"]
                  ),
                  label: _vm.$getCommonLangValue(_vm.data["custom_field_name"]),
                },
                on: {
                  change: function (time) {
                    _vm.curvalue = time
                  },
                },
              })
            : _vm.data && _vm.data["custom_field_data_type"] == "month"
            ? _c("DateTimePicker", {
                attrs: {
                  rules: Number(_vm.data.is_required)
                    ? _vm.$GetRules(["_Require_Rules"], [null])
                    : [],
                  type: "month",
                  readonly: !_vm.iSEdited,
                  filled: _vm.iSEdited,
                  defaultTime: _vm.curvalue,
                  label: _vm.$getCommonLangValue(_vm.data["custom_field_name"]),
                  placeholder: _vm.$getCommonLangValue(
                    _vm.data["custom_field_placeholder"]
                  ),
                },
                on: {
                  change: function (time) {
                    _vm.curvalue = time
                  },
                },
              })
            : _vm.data && _vm.data["custom_field_data_type"] == "boolean"
            ? _c("BooleanRadioField", {
                attrs: {
                  disabled: !_vm.iSEdited,
                  isRequire: Number(_vm.data.is_required),
                  label: _vm.$getCommonLangValue(_vm.data["custom_field_name"]),
                },
                on: {
                  click: function (boolean) {
                    _vm.curvalue = boolean
                  },
                },
                model: {
                  value: _vm.curvalue,
                  callback: function ($$v) {
                    _vm.curvalue = $$v
                  },
                  expression: "curvalue",
                },
              })
            : _vm.data && _vm.data["custom_field_data_type"] == "file"
            ? _c("MicrosoftFileDragUpdate", {
                attrs: {
                  label: _vm.$getCommonLangValue(_vm.data["custom_field_name"]),
                  disabled: !_vm.iSEdited,
                  validate: _vm.validate,
                  isRequire: Number(_vm.data["is_required"]),
                  defaultImageList: _vm.fileList,
                },
                on: {
                  error: function (val) {
                    _vm.$emit("error", val)
                  },
                  change: function (val) {
                    _vm.curvalue = val
                  },
                },
              })
            : _c("normalInputTextFiled", {
                attrs: {
                  maxlength: "100",
                  readonly: !_vm.iSEdited,
                  filled: _vm.iSEdited,
                  placeholder: _vm.$getCommonLangValue(
                    _vm.data["custom_field_placeholder"]
                  ),
                  label: _vm.$getCommonLangValue(_vm.data["custom_field_name"]),
                  rules: Number(_vm.data.is_required)
                    ? _vm.$GetRules(["_Require_Rules"], [null])
                    : [],
                },
                model: {
                  value: _vm.curvalue,
                  callback: function ($$v) {
                    _vm.curvalue = $$v
                  },
                  expression: "curvalue",
                },
              }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }